import { Equipo, EquipoJSON } from '../Equipo/Equipo';
import { Temporada } from '../Temporada/Temporada';

export interface EquipoXDivisionJSON {
  exd_id: string | null;
  exd_temid: number;
  exd_eqid: number;
  exd_divid: number;
  exd_activo: boolean;
  exd_orden_merito: number;
  equipo: EquipoJSON;
}

export class EquipoXDivision {
  protected constructor(
    private id: string | null,
    private temid: number,
    private eqid: number,
    private divid: number,
    private activo: boolean,
    private ordenMerito: number,
    private equipo: Equipo
  ) {}

  static createFrom(
    id: string | null,
    temid: number,
    eqid: number,
    divid: number,
    activo: boolean,
    ordenMerito: number,
    equipo: Equipo
  ) {
    return new this(id, temid, eqid, divid, activo, ordenMerito, equipo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: EquipoXDivision) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: EquipoXDivisionJSON) {
    return EquipoXDivision.createFrom(
      entity.exd_id,
      entity.exd_temid,
      entity.exd_eqid,
      entity.exd_divid,
      entity.exd_activo,
      entity.exd_orden_merito,
      Equipo.fromJSON(entity.equipo)
    );
  }

  toJSON(): EquipoXDivisionJSON {
    return {
      exd_id: this.getId(),
      exd_temid: this.getTemid(),
      exd_eqid: this.getEqid(),
      exd_divid: this.getDivid(),
      exd_activo: this.getActivo(),
      exd_orden_merito: this.getOrdenMerito(),
      equipo: this.getEquipo().toJSON(),
    };
  }

  static createForDivision(temporada: Temporada, equipo: Equipo, divisionId: number) {
    return EquipoXDivision.createFrom(
      'new',
      Number(temporada.getId()),
      Number(equipo.getId()),
      divisionId,
      true,
      0,
      equipo
    );
  }

  getId(): string | null {
    return this.id;
  }

  getTemid(): number {
    return this.temid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getDivid(): number {
    return this.divid;
  }

  getActivo(): any {
    return this.activo;
  }

  getOrdenMerito(): number {
    return this.ordenMerito;
  }

  getEquipo(): Equipo {
    return this.equipo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setTemid(value: number): void {
    this.temid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setDivid(value: number): void {
    this.divid = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }

  setOrdenMerito(value: number): void {
    this.ordenMerito = value;
  }
}
